import React from "react";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
const ToolTip = (props) => {
  const tooltip = (
    <Tooltip id="button-tooltip">
      {props.title && <strong>{props.title}</strong>}
      {props.info}.
    </Tooltip>
  );
  return (
    <>
      <OverlayTrigger
        placement={props.place ? props.place : "auto-end"}
        overlay={tooltip}
        delay={{ show: props.show ? props.show : 250, hide: 400 }}
      >
        {props.tool ? props.tool : <i class="fa fa-info-circle"></i>}
      </OverlayTrigger>
    </>
  );
};

export default ToolTip;
